import script from "./Traditional.vue?vue&type=script&setup=true&lang=js"
export * from "./Traditional.vue?vue&type=script&setup=true&lang=js"

import "./Traditional.vue?vue&type=style&index=0&id=2b44949e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b44949e"]])

export default __exports__